(() => {
	angular.module('main').directive('mainShootDate', mainShootDate);

	mainShootDate.$inject = ['timeService'];

	function mainShootDate(timeService) {
		return {
			restrict: 'E',
			scope: {
				startDate: '=',
				finishDate: '=',
				doubleBookingJobs: '=',
				doubleBookingLeads: '='
			},
			template: `<span style="display: flex; justify-content: flex-start">
                            <div ng-if="startDate">
                               {{startDate | timeFilter: setStartDateFilter()}}
                                <span ng-show="startDate != finishDate">
                                   - 
                                 <span class="text-nowrap">{{finishDate | timeFilter:'long'}}</span>
                                </span>
                            </div>
                            <span style="display: flex; float: right" ng-if="startDate !== finishDate">

                                    <span ng-if="doubleBookingJobs" class="square-content-job" style="align-self:flex-end">
                                        <sn-warning warning-class="square-job-profile"></sn-warning> 
                                    </span>

                                    <span ng-if="doubleBookingLeads" class="square-content-lead" style="align-self:flex-end">
                                       <sn-warning warning-class="square-lead-profile"></sn-warning>
                                    </span>

                                    </span>
                            <span ng-if="!startDate">No date</span>
                       </span>`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.setStartDateFilter = () => {
					const isYearsEqual = timeService.compareYears(
						scope.startDate,
						scope.finishDate
					);
					const isDatesDifferent = timeService.compareDates(
						scope.startDate,
						scope.finishDate
					);

					const onlyYearsAreEqual = isYearsEqual && isDatesDifferent;

					if (onlyYearsAreEqual) {
						return 'dayAndMonth';
					}

					return 'long';
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Filelds/mainShootDate.js